export function random(min: number, max: number) {
  return Math.random() * (max - min) + min;
}

export function clamp(value: number, x1: number, y1: number) {
  return Math.min(Math.max(value, x1), y1);
}
